<div class="tw-container tw-mx-auto">
  <div
    class="tw-mt-6 tw-w-full tw-rounded-3xl tw-bg-color-surface-card tw-py-8 tw-px-12 shadow-fade-card sm:tw-px-8 sm:tw-mt-0"
  >
    @if (loading) {
      <div class="tw-flex tw-flex-col tw-items-center tw-gap-2 tw-py-8">
        <i class="bwi bwi-spinner bwi-spin tw-text-2xl" aria-hidden="true"></i>
        <p>{{ "loading" | i18n }}</p>
      </div>
    } @else if (failed) {
      <p class="tw-text-center tw-text-danger">{{ "errorOccurred" | i18n }}</p>
    } @else {
      <p class="tw-text-center tw-font-medium tw-text-[14px] tw-mb-3">
        {{ "firstDeviceSetupIntro" | i18n }}
      </p>

      <div class="tw-mb-4">
        <label class="tw-font-semibold tw-text-[14px] tw-text-color-text-tertiary">{{
          "recoveryKey" | i18n
        }}</label>
        <div class="tw-flex tw-items-center tw-gap-2">
          <input
            readonly
            [value]="recoveryKey"
            data-testid="firstDeviceSetupRecoveryKey"
            class="tw-bg-color-surface-input tw-font-mono tw-text-[12px] tw-w-full tw-rounded-lg tw-px-3 tw-py-2 tw-border tw-border-color-border-default"
          />
          <button
            type="button"
            (click)="copyRecoveryKey()"
            data-testid="firstDeviceSetupCopyRecoveryKey"
            class="tw-text-color-text-action tw-text-[12px] tw-font-medium tw-whitespace-nowrap"
          >
            {{ "copyValue" | i18n }}
          </button>
        </div>
        <p class="tw-text-color-text-secondary tw-text-[12px] tw-mt-1">
          {{ "recoveryKeyWarning" | i18n }}
        </p>
      </div>

      <div class="tw-flex tw-items-start tw-gap-2 tw-mb-4">
        <input
          type="checkbox"
          id="firstDeviceSetupConfirmSaved"
          data-testid="firstDeviceSetupConfirmSaved"
          [(ngModel)]="confirmedSaved"
        />
        <label for="firstDeviceSetupConfirmSaved" class="tw-text-[12px]">
          {{ "recoveryKeyConfirmSaved" | i18n }}
        </label>
      </div>

      <app-gloss-button
        [options]="{
          text: 'continue' | i18n,
          type: 'none',
          fullClass: 'tw-bg-dt-custom-teal-11 tw-h-12 tw-w-full tw-px-6 tw-rounded-full',
          onClick: continue.bind(this),
          isEnabled: confirmedSaved && !submitting,
          testId: 'firstDeviceSetupContinueButton',
        }"
        [isLoading]="submitting"
      >
      </app-gloss-button>
    }
  </div>
</div>
